import { Controller } from "@hotwired/stimulus"

// Cambio dell'organizzazione attiva dal menu dell'account (switchOrg dell'originale): alla scelta
// invia POST /app/org/:id/attiva, che ricorda la scelta e riapre /app.
export default class extends Controller {
  cambia(event) {
    const id = event.target.value
    if (!id) return
    this.element.action = `/app/org/${encodeURIComponent(id)}/attiva`
    this.element.requestSubmit()
  }
}
